import * as React from "react"
import {Helmet} from 'react-helmet'

//components
import Layout from '../../components/layout/'
import CarruselPrincipal from '../../components/carrusel'
import GridImagenes from '../../components/imagenes/GridImagenes'
import FormularioContacto from '../../components/formulario'
import Mapa from '../../components/mapa'
import Ubicacion from '../../components/ubicacion/Ubicacion'

const IndexPage = () => {
  const carruselUno = [
    {
        imagen : '/Home/Slider/1_slider/cabo-marques-acapulco-guerero.jpg',
        imagenMovil : '/Home/Slider/1_slider/JPEG/cabo-marques-acapulco-guerero.jpg',
        descripcion: '250 HECTARES IN PRIVATE RESIDENTIAL AREA',
        titulo: 'Cabo Marques, Acapulco Diamante',
        video: 'https://vimeo.com/566670146',
        direccion: 'izquierda',
    },
    {
        imagen : '/Home/Slider/2_slider/macrolotes-cabo-marques.jpg',
        imagenMovil : '/Home/Slider/2_slider/JPEG/macrolotes-cabo-marques.jpg',
        descripcion: 'DEVELOPMENT OPPORTUNIY FOR HOTELS, RESIDENCES, DEPARTMENTS AND SHOPPING CENTERS',
        titulo : 'Macro lots, Cabo Marques',
        direccion: 'izquierda',
        enlace: '/projects/macro-lots'
    },
    {
      imagen : '/Home/Slider/1_slider/acceso-cabo-marques.jpg',
      imagenMovil : '/Home/Slider/1_slider/JPEG/acceso-cabo-marques.jpg',
      descripcion: 'EXCLUSIVE AND PRIVATE LIVING',
      titulo: 'Cabo Marques, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
      imagen : '/Home/Slider/2_slider/los-riscos-cabo-marques.jpg',
      imagenMovil : '/Home/Slider/2_slider/JPEG/los-riscos-cabo-marques.jpg',
      descripcion: '21 HECTARES WITH UNBREAKABLE RESPECT FOR NATURE',
      titulo : 'Los Riscos, Cabo Marques',
      direccion: 'izquierda',
      enlace: '/projects/los-riscos'
    },
    {
      imagen : '/Home/Slider/1_slider/helipuerto-cabo-marques.jpg',
      imagenMovil : '/Home/Slider/1_slider/JPEG/helipuerto-cabo-marques.jpg',
      descripcion: 'ACCESS VIA LAND, SEA, AND AIR',
      titulo: 'Cabo Marques, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
      imagen : '/Home/Slider/2_slider/banyan-tree-cabo-marques.jpg',
      imagenMovil : '/Home/Slider/2_slider/JPEG/banyan-tree-cabo-marques.jpg',
      descripcion: 'FIVE DIAMOND HOTEL AND WORLD-CLASS RESTAURANTS',
      titulo : 'Banyan Tree, Cabo Marques',
      direccion: 'izquierda',
      enlace: '/projects/banyan-tree'
    },
    {
      imagen : '/Home/Slider/1_slider/vialidades-cabo-marques.jpg',
      imagenMovil : '/Home/Slider/1_slider/JPEG/vialidades-cabo-marques.jpg',
      descripcion: '100% URBANIZED, CONDOMINIUMS AND OPERATING SERVICES',
      titulo: 'Cabo Marques, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
        imagen : '/Home/Slider/2_slider/marina-cabo-marques.jpg',
        imagenMovil : '/Home/Slider/2_slider/JPEG/marina-cabo-marques.jpg',
        descripcion: 'THE ONLY MARINA IN ACAPULCO DIAMANTE',
        titulo : 'Marina Cabo Marques, Acapulco Diamante',
        direccion: 'izquierda',
        enlace: '/projects/marina-cabo-marques'
    },
    {
      imagen : '/Home/Slider/1_slider/club-de-playa-de-suka-y-sal.jpg',
      imagenMovil : '/Home/Slider/1_slider/JPEG/club-de-playa-de-suka-y-sal.jpg',
      descripcion: 'ACCESS TO TWO BEACHES FROM THE DEVELOPMENT',
      titulo: 'Cabo Marques, Acapulco Diamante',
      direccion: 'izquierda',
    },
  ]

  return (
    <>
      <Layout english={true}>
        <Helmet defer={false}>
          <meta charSet="utf-8" />
          <title>Cabo Marqués, Acapulco Diamante</title>
          <meta name="description" content="250 HECTARES IN PRIVATE RESIDENTIAL AREA" />
        </Helmet>
        <CarruselPrincipal
          direccion="derecha" 
          imgs={carruselUno}
          english={true}
        />
        <Mapa english={true} />
        <GridImagenes english={true} />
        <Ubicacion english={true} />
        <FormularioContacto english={true} />
      </Layout>
    </>
  )
}

export default IndexPage
